import { select } from 'redux-saga/effects';

import { getInDomain } from '../../domains/externalUtils';

export function* isAPS(action) {
  const { sourceId } = action.data;
  return yield select(getInDomain('playback.utils.isPlaylistModelTypeAPSItem', false), sourceId);
}
